import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as Styles from './newsletter-field.module.scss';

function NewsletterField({ value, onChange }) {
  return (
    <label htmlFor="newsletter" className={classNames('form-check-label', Styles.label)}>
      <input
        type="checkbox"
        id="newsletter"
        checked={value}
        onChange={onChange}
        className={classNames('form-check-input')}
      />
      <span>
        Sign up for Your Hot Job emails to receive free lesson plans, the full unit of study, teaching resources, and more.
      </span>
    </label>
  );
}

NewsletterField.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NewsletterField;
